import React, { Component } from "react";
import { View, StatusBar, TextInput, Text, Animated } from "react-native";
import { scale } from "@utils/scale";
import Verified from "@assets/svg/Verified";

export class FloatingLabelInput extends Component {
  state = {
    isFocused: false,
  };
  constructor(props) {
    super(props);
    this._animatedIsFocused = new Animated.Value(
      this.props.value === "" ? 0 : 1,
    );
  }

  componentDidUpdate() {
    Animated.timing(this._animatedIsFocused, {
      toValue: this.state.isFocused || this.props.value !== "" ? 1 : 0,
      duration: 200,
    }).start();
  }
  handleFocus = () => this.setState({ isFocused: true });
  handleBlur = () => this.setState({ isFocused: false });

  render() {
    const { label, ...props } = this.props;
    const labelStyle = {
      fontFamily: "Mukta",
      position: "absolute",
      left: 0,
      top: this._animatedIsFocused.interpolate({
        inputRange: [0, 1],
        outputRange: [18, 0],
      }),
      fontSize: this._animatedIsFocused.interpolate({
        inputRange: [0, 1],
        outputRange: [scale(20), scale(12)],
      }),
      color: this._animatedIsFocused.interpolate({
        inputRange: [0, 1],
        outputRange: ["#aaa", "#000"],
      }),
    };
    return (
      <View style={{ paddingTop: 18 }}>
        <Animated.Text style={labelStyle}>{label}</Animated.Text>
        <View style={{ flexDirection: "row", width: "100%" }}>
          <TextInput
            {...props}
            style={{
              height: 26,
              flex: 1,
              padding: 0,
              fontSize: scale(16),
              color: "rgba(0,0,0,.86)",
              borderBottomWidth: 0,
              borderBottomColor: "rgba(0,0,0,.1)",
            }}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            blurOnSubmit
          />
          {this.props.isVerified && (
            <View>
              <Verified />
            </View>
          )}
        </View>
        <View
          style={{
            width: "100%",
            height: 1,
            backgroundColor: "rgba(0,0,0,.1)",
          }}
        />
      </View>
    );
  }
}
